import { defineStore } from 'pinia';
import { useCardBenefitsStore } from './card-benefits';

export const useDecisionsModalStore = defineStore('decisionsModal', {
    state: () => ({
        activeModal: null, // 'annual-fees' | 'min-spend' | 'expiring-benefits' | 'unmatched-cards' | 'welcome-bonus'
        data: null,
        loading: false,
        walletId: null,
    }),

    getters: {
        annualFees: (state) => state.data?.annualFees || [],
        unmatchedCards: (state) => state.data?.unmatchedCards || [],
        minSpendDeadlines: (state) => state.data?.minSpendDeadlines || [],
        welcomeBonusPastDeadline: (state) => state.data?.welcomeBonusPastDeadline || [],

        expiringBenefits() {
            const benefitsStore = useCardBenefitsStore();
            const now = new Date();

            const windowDays = {
                monthly: 7,
                statement: 7,
                quarterly: 14,
            };
            const defaultWindow = 30;

            return benefitsStore.benefits.filter((item) => {
                if (!item.period_end_date) return false;
                if (item.is_active === false) return false;

                const periodType = (item.benefit?.period_type || 'annual').toLowerCase();
                const days = windowDays[periodType] ?? defaultWindow;

                const cutoff = new Date();
                cutoff.setDate(cutoff.getDate() + days);

                const end = new Date(item.period_end_date);
                if (end < now || end > cutoff) return false;

                // Only show benefits with unused value remaining
                const displayAmount = benefitsStore.calculateDisplayAmount(item);
                const used = parseFloat(item.current_period_usage || 0);
                return used < displayAmount;
            });
        },
    },

    actions: {
        setWalletId(id) {
            this.walletId = id;
        },

        async openModal(type) {
            this.activeModal = type;

            if (type === 'expiring-benefits') {
                const benefitsStore = useCardBenefitsStore();
                if (benefitsStore.benefits.length === 0 && this.walletId) {
                    benefitsStore.setWalletId(this.walletId);
                    await benefitsStore.fetchBenefits();
                }
                return;
            }

            if (!this.data) {
                await this.fetchData();
            }
        },

        closeModal() {
            this.activeModal = null;
        },

        async fetchData() {
            this.loading = true;
            try {
                const response = await window.ApiService.apiCall('/wallets/decisions', 'GET');
                this.data = response.data;
            } catch (e) {
                console.error('Failed to fetch decisions data', e);
            } finally {
                this.loading = false;
            }
        },
    },
});
